/// <reference path="references.ts" />
//Helper namespace containing several utility functions
var Apfco;
(function (Apfco) {
    //Converts values returned by document.getElementsByClassName() - Taken from here: https://stackoverflow.com/questions/12686927/typescript-casting-htmlelement
    function ConvertNodeListToArray(inputNodeList) {
        var elementList = [];
        if (inputNodeList) {
            for (var i = 0; i < inputNodeList.length; i++) {
                var node = inputNodeList[i];
                // Make sure it's really an Element
                if (node.nodeType == Node.ELEMENT_NODE) {
                    elementList.push(node);
                }
            }
        }
        return elementList;
    }
    Apfco.ConvertNodeListToArray = ConvertNodeListToArray;
    //Update query string parameters - Taken from here: https://stackoverflow.com/questions/5999118/add-or-update-query-string-parameter
    function UpdateQueryString(key, value, url) {
        if (!url)
            url = window.location.href;
        var re = new RegExp("([?&])" + key + "=.*?(&|#|$)(.*)", "gi"), hash;
        if (re.test(url)) {
            if (typeof value !== 'undefined' && value !== null)
                return url.replace(re, '$1' + key + "=" + value + '$2$3');
            else {
                hash = url.split('#');
                url = hash[0].replace(re, '$1$3').replace(/(&|\?)$/, '');
                if (typeof hash[1] !== 'undefined' && hash[1] !== null)
                    url += '#' + hash[1];
                return url;
            }
        }
        else {
            if (typeof value !== 'undefined' && value !== null) {
                var separator = url.indexOf('?') !== -1 ? '&' : '?';
                hash = url.split('#');
                url = hash[0] + separator + key + '=' + value;
                if (typeof hash[1] !== 'undefined' && hash[1] !== null)
                    url += '#' + hash[1];
                return url;
            }
            else
                return url;
        }
    }
    Apfco.UpdateQueryString = UpdateQueryString;
    //Example, changes http://localhost:61222/?test=123#NavContent to http://localhost:61222/ - From https://stackoverflow.com/questions/2540969/remove-querystring-from-url
    function StripQueryStringAndHashFromUrl(url) {
        return url.split(/[?#]/)[0];
    }
    Apfco.StripQueryStringAndHashFromUrl = StripQueryStringAndHashFromUrl;
    //Use in async functions to insert a delay before continuing processing. Example: await Apfco.Sleep(2000);
    function Sleep(milliseconds) {
        return new Promise(function (resolve) {
            setTimeout(resolve, milliseconds);
        });
    }
    Apfco.Sleep = Sleep;
    //Replace all instances of a value in a string - native string.replace() only works on first instance
    function ReplaceAll(inputString, findString, replaceString) {
        var inputStringRegEscaped = inputString.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
        return inputString.replace(new RegExp(findString, 'g'), replaceString);
    }
    Apfco.ReplaceAll = ReplaceAll;
    //Use jQuery to disable all form buttons on the page when clicked on - except those marked with apfDontDisableOnSubmit
    //Combined into method as this code needs to be used on some of the review iframe views
    function SetDisableFormButtonsOnSubmit(target) {
        $(target).find('form').each(function () {
            $(this).submit(function (event) {
                $(this).find(':input[type=submit], :button').each(function () {
                    if (!$(this).attr('apfDontDisableOnSubmit')) { //Don't disable if the apfDontDisableOnSubmit="true" attribute exists on the button
                        $(this).prop('disabled', true);
                    }
                });
            });
        });
        $(target).find('form').each(function () {
            var currentForm = this; //Get the current form
            $(this).find(':input[type=submit], :button').each(function () {
                if (!$(this).attr('apfDontDisableOnSubmit')) { //Don't disable if the apfDontDisableOnSubmit="true" attribute exists on the button
                    $(this).click(function (event) {
                        $('<input>').attr({
                            type: 'hidden',
                            name: $(this).attr('name'),
                            value: $(this).val()
                        }).insertBefore($(currentForm).children().first()); //Append to the start of the current form, instead of next to the button itself or the end of the form. Otherwise it may mess with any last-child CSS selectors
                    });
                }
            });
        });
    }
    Apfco.SetDisableFormButtonsOnSubmit = SetDisableFormButtonsOnSubmit;
})(Apfco || (Apfco = {}));
//# sourceMappingURL=Apfco.js.map